import { ColorNeutralWhite } from 'autogen/design-tokens/tokens';
import type { ProductListMenuItemViewModel } from 'autogen/swagger/all';
import { SeeAllIn } from 'autogen/translation-keys/trans-website-shared';
import Menu from 'components/generic/menu';
import useSmartviewManager from 'components/generic/smartview/shared/hooks/useSmartviewManager';
import SmartSideDrawerView from 'components/generic/smartview/smartviewSideDrawer/components/SmartSideDrawerView';
import Icon from 'components/Icon';
import MenuHeader from 'components/sideMenu/components/Menu/components/MenuHeader';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import MenuItemsRenderer, { ItemRenderer } from './MenuItemsRenderer';

/* #region styles */
const StyledSmartSideDrawerView = styled(SmartSideDrawerView)`
    flex-direction: column;
`;

const StyledDefaultMenuSection = styled(Menu.SecondarySection)`
    background-color: ${ColorNeutralWhite};
    &:after {
        width: 100%;
    }

    &:empty {
        display: none;
    }
`;
/* #endregion */

const CategorySideSubMenu = ({ model }: { model: ProductListMenuItemViewModel }) => {
    const { children, itemElement } = model;
    const id = `${itemElement.text}-category-menu`;
    const { t } = useTranslation();
    const { open, close } = useSmartviewManager(id);

    return (
        <>
            <Menu.Item.Button buttonProps={{ onClick: open }} afterSlot={<Icon type="ChevronRight" size={16} />}>
                {itemElement.text}
            </Menu.Item.Button>
            <StyledSmartSideDrawerView name={id} animate={false}>
                <MenuHeader headline={itemElement.text} backButtonCallback={close} styling="White" />
                <Menu>
                    <StyledDefaultMenuSection>
                        {/* create the see all menu item */}
                        <ItemRenderer
                            model={{
                                ...model,
                                itemElement: { ...model.itemElement, text: `${t(SeeAllIn)} ${model.itemElement.text}` }
                            }}
                        />

                        {/* render rest of menu items */}
                        <MenuItemsRenderer menuItems={children} />
                    </StyledDefaultMenuSection>
                </Menu>
            </StyledSmartSideDrawerView>
        </>
    );
};

export default memo(CategorySideSubMenu);
